// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"src_views_PortfolioItem_vue":"da3cde33","src_views_About_vue":"4b4aedb3"}[chunkId] + ".js";
};